export default __webpack_public_path__ + "static/media/image24.ac4effb8.png";